import React, { useEffect, useState } from "react";
import CloudStorage from "../../../../../../CloudStorage/CloudStorage";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import PostNotFound from "../../../../../CustomComponents/AllLoader/PostNotFound";
import { PAGE_SIZE } from "../../../../../../redux/constants";
import { getPostPaginationList } from "../../../../../../redux/project/action";
import OrderPostPagination from "../../../../FindWork/SearchAll/AllPosts/CustomPagination/OrderPostPagination";
import PostStatusLabel from "../../../../../Common/PostStatusLabel";
import { decodeHtml } from "../../../../../../assests/extention/commonfunction";

export default function CompletedContests() {
  const navigate = useNavigate();
  const laung = localStorage.getItem("laung");
  const [lan, setLan] = useState(laung ?? "en");
  const dispatch = useDispatch();
  // const listdata?.response? = useSelector(
  //   ({ posts: { listdata?.response? } }) => listdata?.response?,
  // );

  // useEffect(() => {
  //   dispatch(getCompletesMinePosts(2, 12));
  // }, [dispatch]);

  const [listdata, setListdata] = useState("")
  const [pageNumber, setPageNumber] = useState(0);

  useEffect(() => {
    const data = {
      type: 2,
      index: pageNumber,
      size: PAGE_SIZE,
      status: 12,
      is_mine: 1
    }
    if (data) {
      dispatch(getPostPaginationList(data)).then((res) => {
        setListdata(res)
      })
    }
  }, [pageNumber]);

  return (
    <>
      <div className ="posted-project">
        <OrderPostPagination
          totalitemcounts={listdata?.count}
          size={PAGE_SIZE}
          pageNumber={pageNumber}
          setPageNumber={setPageNumber}
        />
        {/* <h4>Completed Win business Opportunities (WBO) ({listdata?.response?.length})</h4> */}
        <div className ="recent-post">
          {listdata?.response?.length === 0 ? (
            <PostNotFound title={"No Post Found"} />
          ) : (
            listdata?.response?.map((item, index) => (
              <div key={index} className ="post-back">
                <div className ="col-md-5">
                  <h3>{decodeHtml(item.title)}</h3>
                  <PostStatusLabel status={item?.status} />
                </div>
                <div className ="activity col-md-4">
                  <h6>Activity</h6>
                  <div className ="post-img">
                    <p>
                      <img
                        src={`${CloudStorage.cloudurl}/Assets/Images/myorders/proposal.svg`}
                        alt=""
                      />
                      Entries: {item?.proposal_count}
                    </p>
                  </div>
                </div>
                <button
                  onClick={() =>
                    navigate(
                      `/${lan}/dashboard/myorders/contest/active/${item.id}`,
                    )
                  }
                  className ="btn"
                >
                  View details
                  <img
                    src={`${CloudStorage.cloudurl}/Assets/Images/homepage/right-arrow-orange.svg`}
                    alt=""
                  />
                </button>
              </div>
            ))
          )}
        </div>
      </div>
    </>
  );
}
